const unsortedNetworks = Object.values({
  ETH: {
    name: "Ethereum",
    network: "ETH",
    regex: /(?!.*(?:pow|classic))(eth|erc|erc20|ethereum)/gi, // make sure it doesn't match "classic" or "pow"
  },
  SOL: {
    name: "Solana",
    network: "SOL",
    regex: /(sol|solana)/gi,
  },
  BSC: {
    name: "Binance Smart Chain (BEP20)",
    network: "BSC",
    regex: /(bsc|bsc20|bep20)/gi,
  },
  NEAR: {
    name: "NEAR Protocol",
    network: "NEAR",
    regex: /(near)/gi,
  },
  MATIC: {
    name: "Polygon",
    network: "MATIC",
    regex: /(matic|polygon)/gi,
  },
  BNB: {
    name: "BNB Beacon Chain",
    network: "BNB",
    regex: /(bnb|bep2)/gi,
  },
  HNT: {
    name: "Helium",
    network: "HNT",
    regex: /(hnt|helium)/gi,
  },
  ETF: {
    name: "ETF",
    network: "ETF",
    regex: /(etf)/gi,
  },
  NANO: {
    name: "NANO",
    network: "NANO",
    regex: /(nano)/gi,
  },
  AION: {
    name: "AION",
    network: "AION",
    regex: /(aion)/gi,
  },
  DGB: {
    name: "DigiByte",
    network: "DGB",
    regex: /(dgb|digibyte)/gi,
  },
  BCD: {
    name: "Bitcoin Diamond",
    network: "BCD",
    regex: /(bcd|bitcoindiamond)/gi,
  },
  ONT: {
    name: "Ontology",
    network: "ONT",
    regex: /(ont|ontology)/gi,
  },
  BCH: {
    name: "Bitcoin Cash",
    network: "BCH",
    regex: /(bch|bitcoincash)/gi,
  },
  TRX: {
    name: "Tron (TRC20)",
    network: "TRX",
    regex: /(trx|tron|trc20)/gi,
  },
  ARBITRUM: {
    name: "Arbitrum One",
    network: "ARBITRUM",
    regex: /(arbitrum|arbitrumone|arbi)/gi,
  },
  AR: {
    name: "Arweave",
    network: "AR",
    regex: /(ar|arweave)/gi,
  },
  IRIS: {
    name: "IRISnet",
    network: "IRIS",
    regex: /(iris)/gi,
  },
  AVAXC: {
    name: "AVAX C-Chain",
    network: "AVAXC",
    regex: /(avaxc|avaxc-chain)/gi,
  },
  BCX: {
    name: "BitcoinX",
    network: "BCX",
    regex: /(bcx|bitcoinx)/gi,
  },
  TRIG: {
    name: "TrigX",
    network: "TRIG",
    regex: /(trig|trigx)/gi,
  },
  NEO3: {
    name: "NEO N3",
    network: "NEO3",
    regex: /(neo3|neon3)/gi,
  },
  NEO: {
    name: "Neo Legacy",
    network: "NEO",
    regex: /(neo|neolegacy)/gi,
  },
  VITE: {
    name: "VITE",
    network: "VITE",
    regex: /(vite)/gi,
  },
  ACA: {
    name: "Acala",
    network: "ACA",
    regex: /(aca|acala)/gi,
  },
  ARDR: {
    name: "Ardor",
    network: "ARDR",
    regex: /(ardr|ardor)/gi,
  },
  NEBL: {
    name: "Neblio",
    network: "NEBL",
    regex: /(nebl|neblio)/gi,
  },
  CHZ: {
    name: "Chiliz Chain (CHZ)",
    network: "CHZ",
    regex: /(chz)/gi,
  },
  MINA: {
    name: "Mina",
    network: "MINA",
    regex: /(mina)/gi,
  },
  VET: {
    name: "VeChain",
    network: "VET",
    regex: /(vet|vechain)/gi,
  },
  SGB: {
    name: "Songbird",
    network: "SGB",
    regex: /(sgb|songbird)/gi,
  },
  REI: {
    name: "REI Network",
    network: "REI",
    regex: /(rei|reinetwork)/gi,
  },
  ADA: {
    name: "Cardano",
    network: "ADA",
    regex: /(ada|cardano)/gi,
  },
  ELF: {
    name: "AELF",
    network: "ELF",
    regex: /(elf|aelf)/gi,
  },
  EOS: {
    name: "EOS",
    network: "EOS",
    regex: /(eos)/gi,
  },
  YOYO: {
    name: "YOYOW",
    network: "YOYO",
    regex: /(yoyo|yoyow)/gi,
  },
  WAVES: {
    name: "Waves",
    network: "WAVES",
    regex: /(waves)/gi,
  },
  XRP: {
    name: "Ripple",
    network: "XRP",
    regex: /(xrp|ripple)/gi,
  },
  SCRT: {
    name: "Secret",
    network: "SCRT",
    regex: /(scrt|secret)/gi,
  },
  GRS: {
    name: "Groestlcoin",
    network: "GRS",
    regex: /(grs|groestlcoin)/gi,
  },
  KAVA: {
    name: "KAVA",
    network: "KAVA",
    regex: /(kava)/gi,
  },
  THETA: {
    name: "Theta Network",
    network: "THETA",
    regex: /(theta)/gi,
  },
  SBTC: {
    name: "SBTC",
    network: "SBTC",
    regex: /(sbtc)/gi,
  },
  CKB: {
    name: "Nervos Network",
    network: "CKB",
    regex: /(ckb|nervos)/gi,
  },
  LUNC: {
    name: "Terra Classic",
    network: "LUNC",
    regex: /(lunc|terraclassic)/gi,
  },
  XTZ: {
    name: "Tezos",
    network: "XTZ",
    regex: /(xtz|tezos)/gi,
  },
  LUNA: {
    name: "Terra",
    network: "LUNA",
    regex: /(luna|terra)/gi,
  },
  FTM: {
    name: "Fantom",
    network: "FTM",
    regex: /(ftm|fantom)/gi,
  },
  GO: {
    name: "GoChain",
    network: "GO",
    regex: /(go|gochain)/gi,
  },
  RSK: {
    name: "RSK",
    network: "RSK",
    regex: /(rsk)/gi,
  },
  HC: {
    name: "HyperCash",
    network: "HC",
    regex: /(hc|hypercash)/gi,
  },
  SKY: {
    name: "Skycoin",
    network: "SKY",
    regex: /(sky|skycoin)/gi,
  },
  NAS: {
    name: "Nebulas",
    network: "NAS",
    regex: /(nas|nebulas)/gi,
  },
  NAV: {
    name: "NavCoin",
    network: "NAV",
    regex: /(nav|navcoin)/gi,
  },
  WTC: {
    name: "Walton",
    network: "WTC",
    regex: /(wtc|walton)/gi,
  },
  XVG: {
    name: "Verge",
    network: "XVG",
    regex: /(xvg|verge)/gi,
  },
  FLOW: {
    name: "Flow",
    network: "FLOW",
    regex: /(flow)/gi,
  },
  STEEM: {
    name: "Steem",
    network: "STEEM",
    regex: /(steem)/gi,
  },
  RON: {
    name: "Ronin",
    network: "RON",
    regex: /(ron|ronin)/gi,
  },
  NBS: {
    name: "New BitShares",
    network: "NBS",
    regex: /(nbs|newbitshares)/gi,
  },
  IOST: {
    name: "IOST",
    network: "IOST",
    regex: /(iost)/gi,
  },
  DOT: {
    name: "Polkadot",
    network: "DOT",
    regex: /(dot|polkadot)/gi,
  },
  ATOM: {
    name: "Cosmos",
    network: "ATOM",
    regex: /(atom|cosmos)/gi,
  },
  OPTIMISM: {
    name: "Optimism",
    network: "OPTIMISM",
    regex: /(optimism)/gi,
  },
  ROSE: {
    name: "Oasis Network",
    network: "ROSE",
    regex: /(rose|oasis)/gi,
  },
  GLMR: {
    name: "Moonbeam",
    network: "GLMR",
    regex: /(glmr|moonbeam)/gi,
  },
  XYM: {
    name: "Symbol",
    network: "XYM",
    regex: /(xym|symbol)/gi,
  },
  ETC: {
    name: "Ethereum Classic",
    network: "ETC",
    regex: /(etc|ethclassic|ethereumclassic)/gi,
  },
  BIFROSTKUSAMA: {
    name: "BIFROSTKUSAMA",
    network: "BIFROSTKUSAMA",
    regex: /(bifrostkusama)/gi,
  },
  TOMO: {
    name: "TomoChain",
    network: "TOMO",
    regex: /(tomo|tomochain)/gi,
  },
  CELO: {
    name: "CELO",
    network: "CELO",
    regex: /(celo)/gi,
  },
  KLAY: {
    name: "Klaytn",
    network: "KLAY",
    regex: /(klay|klaytn)/gi,
  },
  GXS: {
    name: "GXChain",
    network: "GXS",
    regex: /(gxs|wxchain)/gi,
  },
  EGLD: {
    name: "MultiversX eGold",
    network: "EGLD",
    regex: /(egld|elrond|multiversx)/gi,
  },
  MA: {
    name: "Manta Network",
    network: "MA",
    regex: /(ma|manta)/gi,
  },
  AMB: {
    name: "Ambrosus",
    network: "AMB",
    regex: /(amb|ambrosus)/gi,
  },
  NULS: {
    name: "Nuls",
    network: "NULS",
    regex: /(nuls)/gi,
  },
  STAKING: {
    name: "STAKING",
    network: "STAKING",
    regex: /(staking)/gi,
  },
  QTUM: {
    name: "Qtum",
    network: "QTUM",
    regex: /(qtum)/gi,
  },
  ETHW: {
    name: "Ethereum (Proof-of-Work)",
    network: "ETHW",
    regex: /(ethw|ethereum_pow|ethereum-pow)/gi,
  },
  CTK: {
    name: "CertiK",
    network: "CTK",
    regex: /(ctk|certik)/gi,
  },
  APT: {
    name: "APT",
    network: "APT",
    regex: /(apt)/gi,
  },
  IOTX: {
    name: "IoTeX",
    network: "IOTX",
    regex: /(iotx|iotex)/gi,
  },
  KDA: {
    name: "Kadena",
    network: "KDA",
    regex: /(kda|kadena)/gi,
  },
  DOCK: {
    name: "DOCK",
    network: "DOCK",
    regex: /(dock)/gi,
  },
  STX: {
    name: "Stacks",
    network: "STX",
    regex: /(stx|stacks)/gi,
  },
  BAND: {
    name: "BAND",
    network: "BAND",
    regex: /(band)/gi,
  },
  ASTR: {
    name: "Astar Network",
    network: "ASTR",
    regex: /(astr|astar)/gi,
  },
  BTC: {
    name: "Bitcoin",
    network: "BTC",
    regex: /(btc|bitcoin)/gi,
  },
  SEGWITBTC: {
    name: "BTC(SegWit)",
    network: "SEGWITBTC",
    regex: /(segwitbtc|btcsegwit)/gi,
  },
  IOTA: {
    name: "MIOTA",
    network: "IOTA",
    regex: /(iota|miota)/gi,
  },
  REEF: {
    name: "Reef",
    network: "REEF",
    regex: /(reef)/gi,
  },
  BTG: {
    name: "Bitcoin Gold",
    network: "BTG",
    regex: /(btg|bitcoingold)/gi,
  },
  ARK: {
    name: "Ark",
    network: "ARK",
    regex: /(ark)/gi,
  },
  BTS: {
    name: "BitShares",
    network: "BTS",
    regex: /(bts|bitshares)/gi,
  },
  ONE: {
    name: "Harmony",
    network: "ONE",
    regex: /(one|harmony|hrc20)/gi,
  },
  ALGO: {
    name: "Algorand",
    network: "ALGO",
    regex: /(algo|algorand)/gi,
  },
  SC: {
    name: "Siacoin",
    network: "SC",
    regex: /(sc|siacoin)/gi,
  },
  PIVX: {
    name: "PIVX",
    network: "PIVX",
    regex: /(pivx)/gi,
  },
  FIRO: {
    name: "Firo",
    network: "FIRO",
    regex: /(firo)/gi,
  },
  ICP: {
    name: "Internet Computer",
    network: "ICP",
    regex: /(icp|internetcomputer)/gi,
  },
  ZEC: {
    name: "Zcash",
    network: "ZEC",
    regex: /(zec|zcash)/gi,
  },
  ICX: {
    name: "ICON",
    network: "ICX",
    regex: /(icx|icon)/gi,
  },
  POLYX: {
    name: "Polymesh",
    network: "POLYX",
    regex: /(polyx|polymesh)/gi,
  },
  ZEN: {
    name: "Horizen",
    network: "ZEN",
    regex: /(zen|horizen)/gi,
  },
  DOGE: {
    name: "Dogecoin",
    network: "DOGE",
    regex: /(doge|dogecoin)/gi,
  },
  HBAR: {
    name: "Hedera Hashgraph",
    network: "HBAR",
    regex: /(hbar|hedera)/gi,
  },
  RVN: {
    name: "Ravencoin",
    network: "RVN",
    regex: /(rvn|ravencoin)/gi,
  },
  OSMO: {
    name: "Osmosis",
    network: "OSMO",
    regex: /(osmo|osmosis)/gi,
  },
  HCC: {
    name: "Happycoin",
    network: "HCC",
    regex: /(hcc|happycoin)/gi,
  },
  SYS: {
    name: "Syscoin",
    network: "SYS",
    regex: /(sys|syscoin)/gi,
  },
  STRAX: {
    name: "Stratis",
    network: "STRAX",
    regex: /(strax|stratis)/gi,
  },
  WAN: {
    name: "Wanchain",
    network: "WAN",
    regex: /(wan|wanchain)/gi,
  },
  MOB: {
    name: "MobileCoin",
    network: "MOB",
    regex: /(mob|mobilecoin)/gi,
  },
  XEC: {
    name: "eCash",
    network: "XEC",
    regex: /(xec|ecash)/gi,
  },
  ZIL: {
    name: "Zilliqa",
    network: "ZIL",
    regex: /(zil|zilliqa)/gi,
  },
  XEM: {
    name: "NEM",
    network: "XEM",
    regex: /(xem|nem)/gi,
  },
  CTX: {
    name: "Cortex",
    network: "CTX",
    regex: /(ctx|cortex)/gi,
  },
  BCHSV: {
    name: "Bitcoin SV",
    network: "BCHSV",
    regex: /(bchsv|bitcoinsv)/gi,
  },
  RUNE: {
    name: "THORChain",
    network: "RUNE",
    regex: /(rune|thorchain)/gi,
  },
  KMD: {
    name: "Komodo",
    network: "KMD",
    regex: /(kmd|komodo)/gi,
  },
  AVAX: {
    name: "Avalanche",
    network: "AVAX",
    regex: /(avax|avalanche)/gi,
  },
  HIVE: {
    name: "Hive",
    network: "HIVE",
    regex: /(hive)/gi,
  },
  WAX: {
    name: "WAX",
    network: "WAX",
    regex: /(wax)/gi,
  },
  FET: {
    name: "Fetch.AI",
    network: "FET",
    regex: /(fet|fetch)/gi,
  },
  EDG: {
    name: "Edgeware",
    network: "EDG",
    regex: /(edg|edgeware)/gi,
  },
  DASH: {
    name: "Dash",
    network: "DASH",
    regex: /(dash)/gi,
  },
  LSK: {
    name: "Lisk",
    network: "LSK",
    regex: /(lsk|lisk)/gi,
  },
  BEAM: {
    name: "Beam",
    network: "BEAM",
    regex: /(beam)/gi,
  },
  DCR: {
    name: "Decred",
    network: "DCR",
    regex: /(dcr|decred)/gi,
  },
  XLM: {
    name: "Stellar",
    network: "XLM",
    regex: /(xlm|stellar)/gi,
  },
  LTC: {
    name: "Litecoin",
    network: "LTC",
    regex: /(ltc|litecoin)/gi,
  },
  INJ: {
    name: "Injective",
    network: "INJ",
    regex: /(inj|injective)/gi,
  },
  PARA: {
    name: "Paralink",
    network: "PARA",
    regex: /(para|paralink)/gi,
  },
  LTO: {
    name: "LTO Network",
    network: "LTO",
    regex: /(lto|ltonetwork)/gi,
  },
  NXS: {
    name: "Nexus",
    network: "NXS",
    regex: /(nxs|nexus)/gi,
  },
  EFI: {
    name: "Efinity",
    network: "EFI",
    regex: /(efi|efinity)/gi,
  },
  KSM: {
    name: "Kusama",
    network: "KSM",
    regex: /(ksm|kusama)/gi,
  },
  FIL: {
    name: "Filecoin",
    network: "FIL",
    regex: /(fil|filecoin)/gi,
  },
  FIO: {
    name: "FIO Protocol",
    network: "FIO",
    regex: /(fio|fioprotocol)/gi,
  },
  VIA: {
    name: "Viacoin",
    network: "VIA",
    regex: /(via|viacoin)/gi,
  },
  MOVR: {
    name: "Moonriver",
    network: "MOVR",
    regex: /(movr|moonriver)/gi,
  },
  XMR: {
    name: "Monero",
    network: "XMR",
    regex: /(xmr|monero)/gi,
  },
  DESO: {
    name: "Decentralized Social",
    network: "DESO",
    regex: /(deso|decentralizedsocial)/gi,
  },
  EOSIO: {
    name: "EOSIO",
    network: "EOSIO",
    regex: /(eosio)/gi,
  },
  DFINITY: {
    name: "Dfinity",
    network: "DFINITY",
    regex: /(dfinity)/gi,
  },
  APTOS: {
    name: "Aptos",
    network: "APTOS",
    regex: /(aptos)/gi,
  },
  IMX: {
    name: "Immutable X",
    network: "IMX",
    regex: /(imx|immutablex)/gi,
  },
  LIQUID: {
    name: "Liquid Network",
    network: "LIQUID",
    regex: /(liquid)/gi,
  },
  HEZ: {
    name: "Hermez Network",
    network: "HEZ",
    regex: /(hez|hermez)/gi,
  },
  OMG: {
    name: "OmiseGO Network",
    network: "OMG",
    regex: /(omg|omisego)/gi,
  },
  DVF: {
    name: "DeversiFi",
    network: "DVF",
    regex: /(dvf|deversifi)/gi,
  },
  OMNI: {
    name: "Omni",
    network: "OMNI",
    regex: /(omni)/gi,
  },
  NRG: {
    name: "ENERGI",
    network: "NRG",
    regex: /(nrg|energi)/gi,
  },
  KCS: {
    name: "KuCoin Community Chain",
    network: "KCS",
    regex: /(kcc|kcs|kucoincommunitychain)/gi,
  },
  NIM: {
    name: "Nimiq",
    network: "NIM",
    regex: /(nim|nimiq)/gi,
  },
  ENQ: {
    name: "Enecuum",
    network: "ENQ",
    regex: /(enq|enecuum)/gi,
  },
  SXP: {
    name: "Solar Blockchain",
    network: "SXP",
    regex: /(sxp|solar)/gi,
  },
});

const matchingCount = (network: (typeof unsortedNetworks)[0]) => {
  const { regex } = network;
  const matches = unsortedNetworks.filter((n) => regex.test(n.regex.source));
  return matches.length;
};

// Put the regex that maches the most sources last, and sort among equal matches
export const networks = unsortedNetworks
  .sort((a, b) => {
    const aMatches = matchingCount(a);
    const bMatches = matchingCount(b);
    if (aMatches > bMatches) {
      return 1;
    }
    if (aMatches < bMatches) {
      return -1;
    }
    return 0;
  })
  .sort((a, b) => {
    if (a.regex.test(b.regex.source)) {
      return 1;
    }
    if (b.regex.test(a.regex.source)) {
      return -1;
    }
    return 0;
  });
